export const formatPostcode = postcode => {
  return postcode?.replace(/^(.*\S)\s*(\d)/, "$1 $2").toUpperCase()
}
